import { GeoJSONSource } from 'mapbox-gl';
import { IndustryNews } from '../../../models/industry-news.model';
import GeoHelper from '../../../utils/geo-helpers.utils';
import MapHelpers from '../../map.utils';
import MapLayer from '../map-layer.enum';

function setIndustryNewsFeatures(
  layerId: MapLayer | string,
  industryNews: IndustryNews[]
) {
  const filteredIndustryNews = industryNews.filter(
    (news) => news.lat !== null && news.lng !== null
  );
  const features =
    GeoHelper.industryNewsToGeoJSONFeatures(filteredIndustryNews);
  const geojson = GeoHelper.createGeoJSON(features);
  (MapHelpers.getSource(layerId) as GeoJSONSource)?.setData(geojson);
}

export default setIndustryNewsFeatures;
